import React, {Fragment} from 'react';
import { Field, reduxForm } from 'redux-form';
import { validate, validators, combine } from 'validate-redux-form';
import { renderField } from 'Utils/renderField';
import CardEmpty from 'Utils/Cards/CardEmpty';
import {Link} from 'react-router-dom';

const ChangeForm = (props) => {
    const { handleSubmit } = props;
    return (
        <CardEmpty>
            <form name="loginForm" className="form-validate col-12 px-0 my-3" onSubmit={handleSubmit}>
                <div className="col-12 d-flex align-items-center justify-content-center">
                    <img src={require('assets/img/logo.png')} alt="Logo" className="img-fluid logo-reset"/>
                </div>
                <div className="col-12 d-flex flex-column align-items-center">
                    <h3 className="mt-4 mb-3 text-center gris-oscuro bold">BIENVENIDO</h3>
                    <div className="form-group has-feedback col-lg-10 col-12 px-0">
                        <label htmlFor="password">Nueva contraseña</label>
                        <Field name="password" component={renderField} type="password" className="form-control" />
                    </div>
                    <div className="form-group has-feedback col-lg-10 col-12 px-0">
                        <label htmlFor="password_confirmation">Confirmar contraseña</label>
                        <Field name="password_confirmation" component={renderField} type="password" className="form-control" />
                    </div>
                    <div className="col-12 d-flex flex-wrap justify-content-center align-items-center mt-3 mb-3">
                        {/* <div className="col-md-6 col-12">
                            <Link className="btn btn-secondary btn-block" to="/login">Cancelar</Link>
                        </div> */}
                        <div className="col-md-6 col-12 mt-md-0 mt-3">
                            <button type="submit" className="btn btn-primary btn-block">Cambiar contraseña</button>
                        </div>
                    </div>
                </div>
            </form>
        </CardEmpty>
    );
};

export default reduxForm({
    form: 'login', // a unique identifier for this form
    validate: (data) => {
        return validate(data, {
            password: validators.exists()('Este campo es requerido'),
            password_confirmation: combine(
                validators.exists()('Este campo es requerido'),
                validators.equals(data.password)('La contraseña no coincide')
            ),
        });
    },
})(ChangeForm);
